import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeStepAction,
  setInvalidLoginAction,
  setTokenAction,
} from "../../redux/actions/actions";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import signOut from "../../functions";
import { AuthorizationService } from "../authorizationService";
import { useNavigate } from "react-router-dom";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
const ErrorBoundary = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState([]);
  const [errorVisible, setErrorVisible] = useState(false);
  const [errorType, setErrorType] = useState("");
  const { isAuthError } = useSelector((state) => state.error);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleCloseModal = async (e) => {
    if (isAuthError) {
      await dispatch(changeStepAction(0));
      navigate("/");
    }
    e.preventDefault();
    setErrorVisible(false);
  };
  async function refreshToken() {
    // const tokenPlace = localStorage.getItem("personalStudioRefreshToken")
    //   ? "local"
    //   : "session";
    // const sessionToken = sessionStorage.getItem("personalStudioRefreshToken")
    //   ? JSON.parse(sessionStorage.getItem("personalStudioRefreshToken"))
    //   : "";
    const localToken = localStorage.getItem("personalStudioRefreshToken")
      ? JSON.parse(localStorage.getItem("personalStudioRefreshToken"))
      : "";
    if (localToken) {
      const request = {
        method: "post",
        path: "/refresh",
        data: {
          refresh_token: localToken,
        },
      };
      const data = await AuthorizationService.send(request, (response) => {});
      if (data.errors) {
        // const err = data;
        // const errorEvent = new ErrorEvent("error", {
        //   error: err,
        // });
        // window.dispatchEvent(errorEvent);
        handleSignOut();
        return;
      }
      dispatch(setTokenAction(data));
      // if (tokenPlace === "local") {
      localStorage.setItem(
        "personalStudioAccessToken",
        JSON.stringify(data.access_token)
      );
      localStorage.setItem(
        "personalStudioRefreshToken",
        JSON.stringify(data.refresh_token)
      );
      // }
      // if (tokenPlace === "session") {
      //   localStorage.setItem(
      //     "personalStudioAccessToken",
      //     JSON.stringify(data.access_token)
      //   );
      //   localStorage.setItem(
      //     "personalStudioRefreshToken",
      //     JSON.stringify(data.refresh_token)
      //   );
      // }
      // location.reload();
    } else {
      handleSignOut();
    }
  }
  const handleSignOut = () => {
    console.log("handleSignOut в ErrorBoundary");

    signOut(dispatch);
  };
  useEffect(() => {
    const errorHandler = (errorEvent) => {
      setErrorType(errorEvent.error.error_type);
      switch (errorEvent.error.error_type) {
        case "login":
          dispatch(
            setInvalidLoginAction({
              isValidLogin: false,
              messageError: errorEvent.error.errors,
            })
          );
          break;
        case "auth":
          refreshToken();
          break;
        case "unassigned":
          setErrorVisible(false);
          break;
        case "other":
          setErrorVisible(true);
          setErrorMessage(errorEvent.error.errors);
          break;
        case "info":
          setErrorVisible(true);
          setErrorMessage(errorEvent.error.errors);
          break;
        default:
          setErrorVisible(true);
          setErrorMessage(errorEvent.error.errors);
          break;
      }
    };
    window.addEventListener("error", errorHandler);

    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);
  if (errorVisible) {
    return (
      <>
        {children}

        <BootstrapDialog
          onClose={handleCloseModal}
          aria-labelledby="customized-dialog-title"
          open={errorVisible}
          sx={{ zIndex: 1402 }}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleCloseModal}
          >
            {errorType !== "info" && (
              <Typography variant="h5" color="#ff0000">
                Ошибка
              </Typography>
            )}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            {errorMessage &&
              errorMessage.map((el) => (
                <Typography gutterBottom>{el}</Typography>
              ))}
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCloseModal}>
              Ок
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </>
    );
  }

  return children;
};

export default ErrorBoundary;
